import React, { createContext, useContext, ReactNode } from 'react';

export type ThemeType = 'green' | 'neutral';

interface ThemeContextType {
  currentTheme: ThemeType;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeContextProviderProps {
  children: ReactNode;
}

export function ThemeContextProvider({ children }: ThemeContextProviderProps) {
  // Fixed to 'neutral' theme - theme switching removed
  const currentTheme: ThemeType = 'neutral';

  return (
    <ThemeContext.Provider value={{ currentTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme(): ThemeContextType {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeContextProvider');
  }
  return context;
}